import { VisitingCardDetails } from "../../../interfaces/VisitingCardObject";

/**
 * moreDetails' raw visiting card → VisitingCardDetails, or null when it is
 * missing or not the stored shape. moreDetails is an untyped pass-through, so
 * nothing guarantees `phones` is a string list — a bad row is dropped here
 * rather than crashing the card form that maps over it.
 */
export function parseVisitingCard(raw: unknown): VisitingCardDetails | null {
  let value = raw;
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }
  if (!value || typeof value !== "object") return null;
  const card = value as Record<string, unknown>;
  const phones = Array.isArray(card.phones)
    ? card.phones.filter((phone): phone is string => typeof phone === "string" && phone.trim() !== "")
    : [];
  const address = typeof card.address === "string" ? card.address : "";
  if (phones.length === 0 && !address) return null;
  return {
    phones,
    address,
    email: typeof card.email === "string" && card.email ? card.email : undefined,
  };
}
